/* Add-to-cart toast. Listens for rh:cart:added / rh:cart:error (cart-drawer.js, rh-cart-state.js). */
class RHCartToast extends HTMLElement {
  connectedCallback() {
    const q = (s) => this.querySelector(s);
    this.timer = q('.rh-toast__timer');
    this.img = q('.rh-toast__th img');
    // Close when the timer line finishes (it pauses on hover/focus via CSS), or on the close button.
    this.timer.addEventListener('animationend', () => this.hide());
    q('[data-close]').addEventListener('click', () => this.hide());
    q('[data-view-cart]').addEventListener('click', () => {
      this.hide();
      document.querySelector('mini-cart')?.open();
    });
    this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.hide(); });
    document.addEventListener('rh:cart:added', (e) => this.show(e.detail.items, e.detail.cart));
    document.addEventListener('rh:cart:error', (e) => this.showError(e.detail && e.detail.message));
    // Drawer opened by any route (header Cart click etc.): drop the toast.
    const drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(() => { if (drawer.querySelector('details[open]')) this.hide(); })
      .observe(drawer, { attributes: true, attributeFilter: ['open'], subtree: true });
  }

  money(cents) {
    return window.Shopify && Shopify.formatMoney
      ? Shopify.formatMoney(cents, Shopify.money_format || '${{amount}}')
      : '$' + (cents / 100).toFixed(2);
  }

  // Same markup as price-money: raised cents (superscript decimals) and a smaller currency symbol.
  priceHtml(cents) {
    const m = this.money(cents).replace(/<[^>]*>/g, '').match(/^(\D*?)\s*(\d[\d,. ]*?)([.,]\d{2})?$/);
    return m
      ? `<span class="price"><bdi><span class="price__prefix">${m[1]}</span>${m[2]}${m[3] ? `<sup class="price__suffix">${m[3]}</sup>` : ''}</bdi></span>`
      : this.money(cents);
  }

  // The brand is shown on its own line above, so drop a leading "Vendor " from the title (as snippets/rh-display-title does).
  displayTitle(title, vendor) {
    const head = vendor ? vendor.length + 1 : 0;
    return head && title.length > head && title.slice(0, head).toLowerCase() === vendor.toLowerCase() + ' ' && title.slice(head).trim()
      ? title.slice(head).trim() : title;
  }

  show(items, cart) {
    const item = (items || [])[0];
    if (!item) return;
    const set = (s, t) => { this.querySelector(s).textContent = t; };
    set('[data-vendor]', item.vendor || '');
    set('[data-title]', this.displayTitle(item.title, item.vendor));
    const v = this.querySelector('[data-variant]');
    v.textContent = item.variant_title || '';
    v.hidden = !item.variant_title || item.variant_title === 'Default Title';
    this.querySelector('[data-price]').innerHTML = this.priceHtml(item.final_price);
    if (item.image) {
      const u = new URL(item.image, location.href);
      u.searchParams.set('width', '200');
      this.img.src = u.href;
      this.img.hidden = false;
    } else {
      this.img.hidden = true;
    }
    const label = this.querySelector('[data-view-cart]');
    label.textContent = label.dataset.label.replace('#', cart ? cart.item_count : '');
    this.open('added');
  }

  showError(message) {
    const err = this.querySelector('[data-error]');
    // Raw refresh failures ("cart 500") are not shopper-facing.
    err.textContent = !message || /^cart \d+$/.test(message) ? err.dataset.fallback : message;
    this.open('error');
  }

  open(state) {
    this.dataset.state = state;
    this.querySelector('[data-error]').hidden = state !== 'error';
    // Place under the header (and later the tracker) at the moment of showing.
    const h = document.querySelector('.shopify-section-header');
    this.style.setProperty('--rh-toast-top', Math.max(0, h ? h.getBoundingClientRect().bottom : 0) + 'px');
    this.removeAttribute('open');
    void this.offsetWidth; // restart the slide-in and the timer line
    this.setAttribute('open', '');
  }

  hide() { this.removeAttribute('open'); }
}
customElements.define('rh-cart-toast', RHCartToast);
